import styled from 'styled-components';

export const WidowBlockStyled = styled.span`
  display: inline-block;
  position: relative;
`;
